import React from "react";
import { Link } from "react-router-dom";
import FooterSection from "../../components/pages/home/footer-section";
import NavbarSection from "../../components/pages/home/navbar-section";
import PageMeta from "../../components/common/page-meta";
import { NotFoundActions, NotFoundPage, NotFoundTitle, NotFoundCopy } from "./style";

const NotFound = () => (
  <NotFoundPage>
    <PageMeta
      title="Page not found — Freddy's"
      description="This page could not be found. Return to Freddy's portfolio."
    />
    <NavbarSection percentage={0} showLine={false} />
    <main>
      <NotFoundTitle>That page wandered off.</NotFoundTitle>
      <NotFoundCopy>
        The link may be old or the address may be incomplete. You can return to
        the homepage and keep exploring.
      </NotFoundCopy>
      <NotFoundActions>
        <Link to="/">Back to homepage</Link>
        <Link to="/thoughts">Read thoughts</Link>
      </NotFoundActions>
    </main>
    <FooterSection />
  </NotFoundPage>
);

export default NotFound;
